import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AccountController } from "../../core/config/controllers/AccountController";

export default function Auth() {
    const [authenticate, setAuthenticate] = useState(false);
    const [data, setData] = useState({});

    async function onSubmit() {
        const res = await AccountController.Login(data);
    }

    function handleChange(e) {
        setData({
            ...data,
            [e.target.name]: e.target.value,
        });
    }

    return (
        <div id="page-container">
            <main id="main-container">
                <div>
                    <div className="row no-gutters bg-primary-op">
                        <div className="hero-static col-md-6 d-flex align-items-center bg-white">
                            <div className="p-3 w-100">
                                <div className="mb-3 text-center">
                                    <a
                                        className="link-fx font-w700 font-size-h1"
                                        href="javascript:void()"
                                    >
                                        <img src={"assets/media/logo.png"} style={{ maxWidth: "150px" }} />
                                    </a>
                                </div>

                                <div className="row no-gutters justify-content-center">
                                    <div className="col-sm-8 col-xl-8">
                                        <div className="js-validation-signin">
                                            <div className="py-3">
                                                <div className="form-group">
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-lg form-control-alt"
                                                        id="email"
                                                        name="email"
                                                        placeholder="Usuário"
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <input
                                                        type="password"
                                                        className="form-control form-control-lg form-control-alt"
                                                        id="password"
                                                        name="password"
                                                        placeholder="Senha"
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <button
                                                    onClick={onSubmit}
                                                    className="btn btn-block btn-hero-lg btn-hero-warning text-dark"
                                                >
                                                    <i className="fa fa-fw fa-sign-in-alt mr-1" /> Entre
                                                </button>
                                                <p className="mt-3 mb-0 text-center">
                                                    <a
                                                        className="btn btn-sm btn-light d-block d-lg-inline-block mb-1"
                                                        onClick={() => (window.location = "#/recover")}
                                                    >
                                                        <i className="fa fa-exclamation-triangle text-muted mr-1" />{" "}
                                                        Recuperar senha
                                                    </a>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            className="hero-static col-md-6 d-none d-md-flex align-items-md-center justify-content-md-center text-md-center bg-image"
                            style={{
                                backgroundImage: "url('assets/media/photos/silvia.png')",
                            }}
                        >
                            <div className="p-3">
                                <p className="display-4 font-w700 text-white mb-3">
                                    Bem Vindo!
                                </p>
                                <p className="font-size-lg font-w600 text-white-75 mb-0">
                                    Rastro+ &copy;{" "}
                                    <span className="js-year-copy">
                                        {new Date().getFullYear()}
                                        -Desenvolvido pela{" "}
                                        <a
                                            className="text-white"
                                            href="https://navigate.one"
                                            target="_blank"
                                        >
                                            Navigate
                                        </a>
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <ToastContainer className="toastr" />
        </div>
    );
}